export { ToasterService } from './toaster.service';
export { ToasterComponent } from './toaster.component';



// WEBPACK FOOTER //
// ./src/app/_screens/_shared/toaster/index.ts